// extracted by mini-css-extract-plugin
export default {"root":"DataSourcesRoot_root__w75Ff","body":"DataSourcesRoot_body__MpFS0","grid":"DataSourcesRoot_grid__hXfhS","card":"DataSourcesRoot_card__YL3KR"};